import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const useCommitteesStore = defineStore('committeesStore', {
  state: () => ({
    endpoint: 'committees',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
